// src/components/OfflinePage.js

import React, { useState, useEffect } from 'react';
import { apiFetchPublicCompanyInfo } from '../api/CompanySidebarApi';
import './OfflinePage.css'; // Import the CSS

const OfflinePage = ({ isRetrying, handleRetryConnection }) => {
  const [companyInfo, setCompanyInfo] = useState({ companyName: 'Your Company', logoUrlToDisplay: null });
  const [userMessage, setUserMessage] = useState(
    "We're having trouble connecting to our services. Please check your internet connection and try again."
  );

  useEffect(() => {
    const getCompanyInfo = async () => {
      try {
        const result = await apiFetchPublicCompanyInfo();
        if (result.status && result.data) {
          setCompanyInfo(result.data);
        }
      } catch (error) {
        console.error("Failed to fetch company info for offline page:", error);
      }
    };

    getCompanyInfo();
  }, []);

  const handleRetryClick = async () => {
    setUserMessage("Checking your connection...");
    try {
      await handleRetryConnection();
      setUserMessage("Connection restored! Reloading the app...");
    } catch (error) {
      console.error("Retry failed:", error);
      setUserMessage(
        "Retry attempted, but unfortunately the internet is still down. Please check your connection and try again."
      );
    }
  };

  return (
    <div className="offline-page">
      {companyInfo.logoUrlToDisplay && (
        <img src={companyInfo.logoUrlToDisplay} alt={`${companyInfo.companyName} logo`} className="company-logo" />
      )}
      <h2 style={{ marginBottom: '10px' }}>Connection Lost</h2>
      <p className="offline-message">{userMessage}</p>
      <button
        onClick={handleRetryClick}
        disabled={isRetrying}
        // Use a data-attribute to pass the state to CSS
        data-state={isRetrying ? 'disabled' : 'enabled'}
        className="retry-button"
      >
        {isRetrying ? "Checking..." : "Retry Connection"}
      </button>
    </div>
  );
};

export default OfflinePage;